<template>
  <div>
    <h4>Chat block</h4>

    <template v-if="chatBlock !== null">
      <table
        class="props-compact mb-3"
      >
        <tr>
          <th>Id</th>
          <td>{{chatBlock.id}}</td>
        </tr>
        <tr>
          <th>Blocker</th>
          <td>
            <user-link
              :user="chatBlock.user"
            />
          </td>
        </tr>
        <tr>
          <th>Begin</th>
          <td>{{chatBlock.ctime | getMomentMinStr}}</td>
        </tr>
        <tr>
          <th>Planned duration</th>
          <td>{{getPlannedDurationStr}}</td>
        </tr>
        <tr>
          <th>Planned end</th>
          <td>{{chatBlock.ftime | getMomentMinStr}}</td>
        </tr>
      </table>

      <p class="prop-lable">Reason</p>
      <p class="mb-4">
        {{chatBlock.reason}}
      </p>

      <player-chat-block-complaints
        :complaints="chatBlock.complaints"
      />
    </template>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerChatBlockComplaints from './PlayerChatBlockComplaints.vue';
import UserLink from './UserLink.vue';
import { getPlayerChatBlockPlannedDurationStr } from '../model/player-chat-block-log';

export default {
  name: 'PlayerChatBlock',

  components: {
    LoadingIndicator,
    UserLink,
    PlayerChatBlockComplaints,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    chatBlockId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      chatBlock: null,
    };
  },

  computed: {
    getPlannedDurationStr() {
      return getPlayerChatBlockPlannedDurationStr(this.chatBlock);
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/chat_block/${this.chatBlockId}`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.');
        return;
      }

      this.chatBlock = data;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },
};
</script>
